// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { ResourceServiceSchedule_abstract } from './../abstract/SagaSchema/ResourceServiceSchedule_abstract';
export class ResourceServiceSchedule extends ResourceServiceSchedule_abstract {}
